import PropTypes from 'prop-types'
import React from 'react'
import rem from '@nobia/zeus-components/lib/styled/rem'
import styled from '@nobia/zeus-components/lib/styled'

import RadioSVG from './RadioSVG'

const Wrapper = styled.div`
  margin: 1px 0 0 1px;
  display: grid;
`
const IconWrapper = styled.div`
  height: ${(p) => rem(p.size || 24)};
  grid-column: 1;
  grid-row: 1;
`

const Input = styled.input`
  visibility: hidden;
  height: ${(p) => rem(p.size || 24)};
  width: ${(p) => rem(p.size || 24)};
  margin: 0;
  padding: 0;
  grid-column: 1;
  grid-row: 1;
`

const checkedBackgroundColor = '#192228'
const defaultBackgroundColor = '#fff'

const Radio = ({
  size,
  checked,
  bgColor,
  borderColor,
  handleChecked,
  name,
  value,
}) => (
  <Wrapper>
    <Input
      id={`radio-${name}-${value}`}
      type="radio"
      name={name}
      value={value}
      checked={checked}
      size={size}
      onChange={() => handleChecked(value)}
    />
    <IconWrapper size={size}>
      <RadioSVG
        size={size}
        dot={{
          fill: checked ? checkedBackgroundColor : defaultBackgroundColor,
        }}
        circle={{
          stroke: borderColor,
          fill: bgColor,
        }}
        checked={checked}
      />
    </IconWrapper>
  </Wrapper>
)

Radio.defaultProps = {
  size: 24,
  checked: false,
  bgColor: defaultBackgroundColor,
  borderColor: checkedBackgroundColor,
  handleChecked: () => {},
  name: '',
  value: '',
}

Radio.propTypes = {
  size: PropTypes.number,
  checked: PropTypes.bool,
  bgColor: PropTypes.string,
  borderColor: PropTypes.string,
  handleChecked: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
}

export default Radio
